import { Box, CircularProgress } from "@mui/material";
import "./app-loader-style.scss"; // Import the styles

const AppLoaderComponent = () => {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                bgcolor: '#fff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box className="prm-logo-animation">
                <img
                    src="/img/prm-logo-color.svg"
                    alt="Company Logo"
                    style={{ width: 100, height: 100 }}
                />
            </Box>
            <CircularProgress color="primary" />
        </Box>
    )
};

export default AppLoaderComponent;